import { Card, CardContent, CardHeader, CardMedia, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import googleMapImage from '../images/googlemap.jpeg';
import PlaceIcon from '@material-ui/icons/Place';
import PhoneIcon from '@material-ui/icons/Phone';
import FacebookIcon from '@material-ui/icons/Facebook';


const useStyle = makeStyles(theme => ({
    root: {
        margin: 12,
        [theme.breakpoints.up('md')]: {
            margin: '84px 12px 12px 12px'
        }
    },
    img: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    link: {
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    }
}))

export default function ContactUs(props) {
    const classes = useStyle();
    const mapLink = 'https://goo.gl/maps/47sTqCugA1wFpfXA8';
    const phoneLink = 'tel:6434-0038'
    const fbGroupLink = 'https://www.facebook.com/groups/821119045398872';

    const redirect = (source) => {
        if (source === 'googlemap') {
            window.location = mapLink;
        } else if (source === 'fb') {
            window.location = fbGroupLink;
        } else if (source === 'phone') {
            window.location = phoneLink;
        }
        
    }

    return (
        <div className={classes.root}>
            <Card>
                <CardMedia
                    className={classes.img}
                    image={googleMapImage}
                    title="map"
                    
                />
                <CardContent>
                    <Typography variant="body2" color="textSecondary" component="p" className={`py-2 ${classes.link}`} onClick={e=>redirect('googlemap')}><PlaceIcon/>   大埔林村陳森記士多對面</Typography>
                    <Typography variant="body2" color="textSecondary" component="p" className={`py-2 ${classes.link}`} onClick={e=>redirect('phone')}><PhoneIcon/>   64340038</Typography>
                    <Typography variant="body2" color="textSecondary" component="p" className={`py-2 ${classes.link}`} onClick={e=>redirect('fb')}><FacebookIcon/>   https://www.facebook.com/groups/821119045398872/</Typography>
                </CardContent>
            </Card>
        </div>
    )
}